import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const FailOver = () => <FontAwesomeIcon icon={['far', 'spinner']} spin className="failover" />
